/// <reference path="../../app.ts" />
namespace Cfnc {

    interface ICfncSelectAddress extends ng.IDirective {

    }

    interface ICfncSelectAddressScope extends ng.IScope {
        showSelector: boolean;
        okCallback: (value) => (value) => void;
        cancelCallback: (value) => (value) => void;
        ngModel: any;
        open: () => void;
    }

    class CfncSelectAddress implements ICfncSelectAddress {
        static directiveId: string = "cfncSelectAddress";
        restrict: string = "E";
        require: string = "?ngModel";
        scope: any = {
            showSelector: "=",
            ngModel: "=",
            okCallback: "=",
            cancelCallback: "="
        }

        constructor(private $parse: ng.IParseService, private $uibModal: ng.ui.bootstrap.IModalService, private $timeout: ng.ITimeoutService, private common: Cfnc.ICommonFactory) {
        }

        link = (scope: ICfncSelectAddressScope, element, attrs, controller) => {
            var self = this;
            scope.$watch(() => { return scope.showSelector; },(show) => {
                if (show) {
                    scope.open();
                }
            });

            scope.open = () => {
                
                var modalInstance = this.$uibModal.open({
                    templateUrl: '/app/directives/cfncSelectAddress/cfncSelectAddressModal.html',
                    controller: 'cfncSelectAddressModal',
                    size: "lg",
                    keyboard: false,
                    backdrop: "static",
                    resolve: {
                        model: function () {
                            return scope.ngModel;
                        }
                    },
                });

                modalInstance.result.then((selectedAddress) => {
                    // would normally use scope.$apply but it keeps getting $digest already in progress error
                    
                    this.$timeout(() => {
                        scope.showSelector = false;
                    });

                    if (scope.okCallback) {
                        scope.okCallback.call(scope.$parent, selectedAddress);

                    }
                },(selectedAddress) => {
                        this.$timeout(() => {
                            scope.showSelector = false;
                        });

                        if (scope.cancelCallback) {
                            scope.cancelCallback.call(scope.$parent, selectedAddress);
                        }
                    });
            };
        };
    }

    angular.module("app").directive(CfncSelectAddress.directiveId, ["$parse", "$uibModal", "$timeout", "common",
        ($parse: ng.IParseService, $uibModal: ng.ui.bootstrap.IModalService, $timeout: ng.ITimeoutService, common: Cfnc.ICommonFactory) =>
            new CfncSelectAddress($parse, $uibModal, $timeout, common)
    ]);
}